const selector = [
  '.button:not(.search-modal__button, .quantity-minus, .quantity-plus, .slideshow-control, .close-button, .button-unstyled)',
  '.button-secondary:not(.button):not(.slideshow-control):not(.button-unstyled)',
  '.button-tertiary:not(.button):not(.button-unstyled)',
  '.button-product:not(.button):not(.button-unstyled)',
  'button.shopify-payment-button__button--unbranded:not(.button-unstyled)',
  '.editorial-card__button',
].join(', ');

function enhanceButton(button) {
  if (!(button instanceof HTMLElement)) return;
  if (button.dataset.buttonHoverSlideEnhanced === 'true') return;

  if (button.classList.contains('button-unstyled')) return;
  if (button.classList.contains('close-button')) return;

  if (button.querySelector('.add-to-cart-text, .add-to-cart-text__content, .add-to-cart-text--added')) return;
  if (button.querySelector('.button__hover-slide')) return;

  const outer = document.createElement('span');
  outer.className = 'button__hover-slide';

  const inner = document.createElement('span');
  inner.className = 'button__hover-slide-inner';

  while (button.firstChild) {
    inner.appendChild(button.firstChild);
  }

  outer.appendChild(inner);
  button.appendChild(outer);

  button.dataset.buttonHoverSlideEnhanced = 'true';
}

function enhanceAll() {
  document.querySelectorAll(selector).forEach(enhanceButton);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enhanceAll, { once: true });
} else {
  enhanceAll();
}

document.addEventListener('shopify:section:load', enhanceAll);
document.addEventListener('shopify:section:select', enhanceAll);
